import PersonEntity from "@/model/entities/resource/entity/PersonEntity";

export default class {
    /*SEGUIR EXATAMENTE ESTE PADRÃO CHAMANDO form: new XXX(), POIS SE MUDAR DARÁ ERRO COM OBJETO NÃO SENDO ALTERADO A CADA INCLUSÃO*/

    constructor() {

        return {
            customerId: 0,
            customerNumber: 0,
            typeCustomerId: 0,
            customerGroupId: 0,
            otherCodeLabel: "",
            providerCodeLabel: "",
            person: new PersonEntity(),
            addressDefault: {
                /*Embed Address version: 1.0*/
                country: "BR",
                zipcode: "",
                street: "",
                number: "",
                complement: "",
                neighborhood: "",
                provinceAbbreviation: "",
                cityId: 0,
                /*-------------------------*/
            },
            hasAddressDelivery: false,
            addressDelivery: {
                /*Embed Address version: 1.0*/
                country: "BR",
                zipcode: "",
                street: "",
                number: "",
                complement: "",
                neighborhood: "",
                provinceAbbreviation: "",
                cityId: 0,
                /*-------------------------*/
            },
            typeProfileTaxationId: 0,
            invoiceBRTypeProfile: 0,
            invoiceBRCompanyTypeStateRegistration: 0,
            invoiceBRSuframa: "",
            invoiceEmail: "",
            typeQualityAppraisalId: 0,
            qualityEmail: "",
            companyId: 0,
            companyBlocked: false,
            sellerId: 0,
            sellerBlocked: false,
            priceListId: 0,
            priceListBlocked: false,
            typePaymentId: 0,
            typePaymentBlocked: false,
            paymentPlanId: 0,
            paymentPlanBlocked: false,
            bankAccountId: 0,
            bankAccountBlocked: false,
            typeOriginCustomerId: 0,
            enableAllCompanies: true,
            enableAllUnits: true,
            contactName: "",
            contactEmail: "",
            contactDepartment: "",
            customerSince: "",
            site: "",
            linkedin: "",
            whatsapp: "",
            instagram: "",
            phone: "",
            note: "",
            status: 1,
            companies: [],
            units: [],
        }

    }
}